module.exports = __webpack_public_path__ + "e6615a99.svg";